import React, { useCallback, useEffect, useRef, useState } from "react";
import { useChartContext } from "../../Context/ChartsContext";
import { AiOutlineEnter } from "react-icons/ai";
import { FiMinusSquare, FiPlusSquare } from "react-icons/fi";
import { getDayDiffBetweenFiscalMonths, getDaysInMonth } from "../../Utilitie";
import TooltipHeader from "../../Extra/TooltipHeader";
import Print from "../../Extra/Print";
const AllBestData = () => {
  const { bestSheetDataObj, setVisibleTable } = useChartContext();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [showTable, setShowTable] = useState({});
  const printRef = useRef();
  useEffect(() => {
    if (
      bestSheetDataObj?.bestSheetData &&
      Object.keys(showTable).length === 0
    ) {
      setShowTable({
        [bestSheetDataObj?.bestSheetData[1]?.F_YEAR]: true,
        [bestSheetDataObj?.bestSheetData[0]?.F_YEAR]: true,
      });
    }
  }, [bestSheetDataObj]);
  const handleDisplay = (fy) => {
    const updated = {
      ...showTable,
      [fy]: showTable[fy] === undefined ? true : !showTable[fy],
    };
    const sortedEntries = Object.entries(updated).sort(([a], [b]) => {
      const getStartYear = (fy) => parseInt(fy.split("_")[0]);
      return getStartYear(a) - getStartYear(b);
    });

    const sortedObject = Object.fromEntries(sortedEntries);

    setShowTable(sortedObject);
  };
  useEffect(() => {
    setVisibleTable(showTable);
  }, [showTable]);
  return (
    <div>
      <div ref={printRef} style={{ maxHeight: "700px", overflowY: "auto" }}>
        <table
          className="table newUiTable table-striped-columns table-hover m-0 p-0"
          style={{
            fontSize: "12px",
            borderCollapse: "collapse",
            width: "100%",
          }}
        >
          {/* Sticky Table Header */}
          <thead
            className="table-dark"
            style={{
              position: "sticky",
              top: 0,
              zIndex: 2,
              backgroundColor: "#343a40",
            }}
          >
            <tr style={{ textAlign: "center", verticalAlign: "middle" }}>
              <th scope="col" style={{ width: "50px" }} rowSpan={2}>
                Sn
              </th>
              <TooltipHeader
                id={`tooltip-2`}
                label="F YEAR"
                tooltip="Financial year"
                rowSpan={2}
              />
              <TooltipHeader
                id={`tooltip-3`}
                label="MEXP RUN"
                tooltip="MAIL EXPRESS RUN"
                colSpan={2}
              />
              <TooltipHeader
                id={`tooltip-4`}
                label="PASS RUN"
                tooltip="PASSENGER RUN"
                colSpan={2}
              />
              <TooltipHeader
                id={`tooltip-5`}
                label="GOODS_INT"
                tooltip="GOODS INTERCHANGE"
                colSpan={2}
              />
              <TooltipHeader
                id={`tooltip-6`}
                label=" T TRAIN RUN"
                tooltip="TOTAL TRAIN RUN"
                // rowSpan={2}
                colSpan={2}
              />
              <TooltipHeader
                id={`tooltip-7`}
                label="DWB"
                tooltip="DIVISIONAL WAGON BALANCE"
                // colSpan={2}
                rowSpan={2}
              />
              <TooltipHeader
                id={`tooltip-8`}
                label="LDG WGN"
                tooltip="LOADED WAGON"
                // rowSpan={2}
                colSpan={2}
              />
              <TooltipHeader
                id={`tooltip-9`}
                label="PUN MAIL"
                tooltip="PUNCTUALITY MAIL EXPRESS"
                rowSpan={2}
              />
              <TooltipHeader
                id={`tooltip-10`}
                label="PUN PASS"
                tooltip="PUNCTUALITY PASSENGER"
                rowSpan={2}
              />
              <TooltipHeader
                id={`tooltip-11`}
                label="SPEED"
                tooltip="SPEED"
                rowSpan={2}
              />
            </tr>
            <tr>
              <th scope="col">Monthly</th>
              <th scope="col">Avg/D</th>
              <th scope="col">Monthly</th>
              <th scope="col">Avg/D</th>
              <th scope="col">Monthly</th>
              <th scope="col">Avg/D</th>
              <th scope="col">Monthly</th>
              <th scope="col">Avg/D</th>
              <th scope="col">Monthly</th>
              <th scope="col">Avg/D</th>
              {/* <th scope="col">Avg/D</th> */}
            </tr>
          </thead>
          {/* Scrollable Table Body */}
          <tbody>
            {bestSheetDataObj?.bestSheetData &&
              bestSheetDataObj?.bestSheetData.map((fyObj, index) => {
                let length = fyObj?.months?.length - 1;
                let startMonth = fyObj?.months[0]?.A_MONTH.toUpperCase();
                let endMonth = fyObj?.months[length]?.A_MONTH.toUpperCase();

                let betweenDays = getDayDiffBetweenFiscalMonths(
                  fyObj.F_YEAR,
                  startMonth,
                  endMonth,
                );

                return (
                  <React.Fragment key={index}>
                    <tr
                      style={{ fontWeight: "bold", cursor: "pointer" }}
                      className={`table-${
                        showTable[fyObj.F_YEAR] ? "dark" : "secondary"
                      }`}
                      onClick={() => handleDisplay(fyObj.F_YEAR)}
                    >
                      <td style={{ width: "50px", fontSize: "13px" }}>
                        <b className="d-flex justify-content-center align-items-center">
                          {showTable[fyObj.F_YEAR] ? (
                            <FiMinusSquare />
                          ) : (
                            <FiPlusSquare />
                          )}
                          - {index + 1}
                        </b>
                      </td>
                      <td>{fyObj.F_YEAR.replace("_", "-")}</td>

                      {!showTable[fyObj.F_YEAR] ? (
                        bestSheetDataObj.fyTotal.map((fyTotalObj, index) =>
                          fyTotalObj.F_YEAR == fyObj.F_YEAR ? (
                            <React.Fragment key={index}>
                              <td>{fyTotalObj?.total_MEXP_RPT}</td>
                              <td>
                                {(
                                  fyTotalObj?.total_MEXP_RPT / betweenDays
                                ).toFixed(0)}
                              </td>
                              <td>{fyTotalObj?.TOTAL_PASS_RPT}</td>
                              <td>
                                {(
                                  fyTotalObj?.TOTAL_PASS_RPT / betweenDays
                                ).toFixed(0)}
                              </td>
                              <td>{fyTotalObj?.total_RKS}</td>
                              <td>
                                {(fyTotalObj?.total_RKS / betweenDays).toFixed(
                                  0,
                                )}
                              </td>
                              <td>
                                {Number(fyTotalObj?.total_MEXP_RPT) +
                                  Number(fyTotalObj?.TOTAL_PASS_RPT) +
                                  Number(fyTotalObj?.total_RKS)}
                              </td>
                              <td>
                                {" "}
                                {(
                                  Number(fyTotalObj?.total_MEXP_RPT) /
                                    betweenDays +
                                  Number(fyTotalObj?.TOTAL_PASS_RPT) /
                                    betweenDays +
                                  Number(fyTotalObj?.total_RKS) / betweenDays
                                ).toFixed(1)}
                              </td>
                              <td>{Number(fyTotalObj.total_DWB).toFixed(0)}</td>
                              {/* <td></td> */}

                              <td>
                                {Number(fyTotalObj.total_LDG_WGN).toFixed(0)}
                              </td>
                              <td>
                                {(
                                  fyTotalObj.total_LDG_WGN / betweenDays
                                ).toFixed(0)}
                              </td>

                              <td>
                                {(
                                  fyTotalObj.total_PUN_MAIL /
                                  fyObj.months.length
                                ).toFixed(2)}
                              </td>
                              <td>
                                {(
                                  fyTotalObj.total_PUN_PASS /
                                  fyObj.months.length
                                ).toFixed(2)}
                              </td>
                              <td>
                                {(
                                  fyTotalObj.total_SPEED / fyObj.months.length
                                ).toFixed(2)}
                              </td>
                            </React.Fragment>
                          ) : null,
                        )
                      ) : (
                        <React.Fragment>
                          <td></td>
                          <td scope="col" colSpan={2}></td>
                          <td scope="col" colSpan={2}></td>
                          <td scope="col" colSpan={2}></td>
                          <td scope="col"></td>
                          <td scope="col"></td>
                          <td scope="col"></td>
                          <td scope="col"></td>
                          <td scope="col"></td>
                          <td scope="col"></td>
                          <td scope="col"></td>
                          {/* <td scope="col"></td> */}
                        </React.Fragment>
                      )}
                    </tr>
                    {fyObj.months &&
                      fyObj.months.map((mObj, ind) => {
                        let days = getDaysInMonth(
                          fyObj.F_YEAR,
                          mObj.A_MONTH.toUpperCase(),
                        );

                        return (
                          <tr
                            key={`${fyObj.F_YEAR}-${ind}`}
                            className={`collapse ${
                              showTable[fyObj.F_YEAR] ? "show" : ""
                            }`}
                            style={{ transition: "height 0.3s ease-in-out" }}
                          >
                            <td
                              className="d-flex justify-content-center align-items-center"
                              style={{ width: "50px" }}
                            >
                              &nbsp;&nbsp;&nbsp;
                              <div
                                style={{
                                  transform: "scaleX(-1)",
                                  // transform: "rotate(90deg)",
                                }}
                              >
                                <AiOutlineEnter />
                              </div>
                              {ind + 1}
                            </td>
                            <td>{mObj.A_MONTH}</td>
                            <td>{mObj.data?.MEXP_RPT}</td>
                            <td>{(mObj.data?.MEXP_RPT / days).toFixed(0)}</td>

                            <td>{mObj.data?.PASS_RPT}</td>
                            <td>{(mObj.data?.PASS_RPT / days).toFixed(0)}</td>

                            <td>{mObj.data?.TOTAL_RKS}</td>
                            <td>{(mObj.data?.TOTAL_RKS / days).toFixed(0)}</td>

                            <td>
                              {Number(mObj.data?.MEXP_RPT) +
                                Number(mObj.data?.PASS_RPT) +
                                Number(mObj.data?.TOTAL_RKS)}
                            </td>
                            <td>
                              {(
                                Number(mObj.data?.MEXP_RPT) / days +
                                Number(mObj.data?.PASS_RPT) / days +
                                Number(mObj.data?.TOTAL_RKS) / days
                              ).toFixed(1)}
                            </td>
                            <td>{Number(mObj.data.DWB).toFixed(0)}</td>
                            {/* <td></td> */}

                            <td>{Number(mObj.data.LDG_WGN).toFixed(0)}</td>
                            <td>{(mObj.data.LDG_WGN / days).toFixed(0)}</td>

                            <td>{mObj.data.PUN_MAIL}</td>
                            <td>{mObj.data.PUN_PASS}</td>
                            <td>{mObj.data.SPEED}</td>
                          </tr>
                        );
                      })}
                    {showTable[fyObj.F_YEAR] ? (
                      <tr className="table-dark" style={{ fontWeight: "bold" }}>
                        {bestSheetDataObj.fyTotal.map((fyTotalObj, index) =>
                          fyTotalObj.F_YEAR == fyObj.F_YEAR ? (
                            <React.Fragment key={index}>
                              <td></td>
                              <td>TOTAL</td>
                              <td>{fyTotalObj?.total_MEXP_RPT}</td>
                              <td>
                                {(
                                  fyTotalObj?.total_MEXP_RPT / betweenDays
                                ).toFixed(0)}
                              </td>
                              <td>{fyTotalObj?.TOTAL_PASS_RPT}</td>
                              <td>
                                {(
                                  fyTotalObj?.TOTAL_PASS_RPT / betweenDays
                                ).toFixed(0)}
                              </td>
                              <td>{fyTotalObj?.total_RKS}</td>
                              <td>
                                {(fyTotalObj?.total_RKS / betweenDays).toFixed(
                                  0,
                                )}
                              </td>
                              <td>
                                {Number(fyTotalObj?.total_MEXP_RPT) +
                                  Number(fyTotalObj?.TOTAL_PASS_RPT) +
                                  Number(fyTotalObj?.total_RKS)}
                              </td>
                              <td>
                                {(
                                  Number(fyTotalObj?.total_MEXP_RPT) /
                                    betweenDays +
                                  Number(fyTotalObj?.TOTAL_PASS_RPT) /
                                    betweenDays +
                                  Number(fyTotalObj?.total_RKS) / betweenDays
                                ).toFixed(1)}
                              </td>

                              <td>
                                {(
                                  fyTotalObj.total_DWB / fyObj?.months.length
                                ).toFixed(0)}{" "}
                              </td>
                              {/* <td></td> */}

                              <td>
                                {Number(fyTotalObj.total_LDG_WGN).toFixed(0)}
                              </td>
                              <td>
                                {(
                                  fyTotalObj.total_LDG_WGN / betweenDays
                                ).toFixed(0)}
                              </td>

                              <td>
                                {(
                                  fyTotalObj.total_PUN_MAIL /
                                  fyObj.months.length
                                ).toFixed(2)}
                              </td>
                              <td>
                                {(
                                  fyTotalObj.total_PUN_PASS /
                                  fyObj.months.length
                                ).toFixed(2)}
                              </td>
                              <td>
                                {(
                                  fyTotalObj.total_SPEED / fyObj.months.length
                                ).toFixed(2)}
                              </td>
                            </React.Fragment>
                          ) : null,
                        )}
                      </tr>
                    ) : null}
                  </React.Fragment>
                );
              })}
          </tbody>
        </table>
      </div>
      <Print title={`op -`} printRef={printRef} />
    </div>
  );
};
export default AllBestData;
